module.exports = __webpack_public_path__ + "img/vusic.07347d36.png";